import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IAirdropTaskRender } from "./task-renderer.types";
import { QuestTaskButton } from "../quest-task-button";
import { cn } from "@/lib/utils";

export const TwitterUsernameRenderer = ({
  task,
  campaign,
  completeTaskMutation,
}: IAirdropTaskRender) => {
  const [copied, setCopied] = useState(false);
  const swapperSymbol = "💱";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(swapperSymbol);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="relative bg-yiedl-gray-200 border-2 border-neutral-800 rounded-2xl p-6 shadow-lg">
        <p className="text-sm text-gray-400 mb-4 leading-relaxed">
          To complete this task, add the 💱 symbol to your Twitter/X username.
        </p>
        <div className="flex items-center gap-3">
          <div className="relative flex items-center justify-center bg-yiedl-primary/10 px-6 py-3 rounded-xl border-2 border-yiedl-primary/20">
            <span className="text-2xl font-bold">💱</span>
          </div>
          <Button
            variant={copied ? "secondary" : "primary"}
            size="sm"
            onClick={handleCopy}
            className="whitespace-nowrap"
          >
            {copied ? (
              <>
                <Check className="w-4 h-4 mr-2" />
                Copied!
              </>
            ) : (
              <>
                <Copy className="w-4 h-4 mr-2" />
                Copy Symbol
              </>
            )}
          </Button>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <h4 className="font-bold text-white">How to update your username:</h4>
        <ol className="list-decimal list-inside space-y-2 text-sm text-gray-400 leading-relaxed">
          <li>Click the &quot;Copy Symbol&quot; button above</li>
          <li>Go to your Twitter/X profile settings</li>
          <li>Click &quot;Edit profile&quot;</li>
          <li>Add 💱 to your name field</li>
          <li>Save your changes</li>
          <li>Come back here and click &quot;Verify & Claim&quot;</li>
        </ol>
      </div>

      <QuestTaskButton
        buttonText="Verify & Claim"
        taskMutation={completeTaskMutation}
        task={task}
        onClick={() => {
          completeTaskMutation.mutateAsync({
            taskGuid: task.taskGuid,
            taskName: task.taskName,
            campaignId: campaign.id,
            extraArguments: task.extraArguments,
            groupId: campaign.campaignGroup,
          });
        }}
      />
    </div>
  );
};
